import { useInView } from "framer-motion"
import { useEffect, useRef } from "react"
import EmpCheckbox, { EmpCheckboxRef } from "../../../components/shared/emp-checkbox/emp-checkbox"
import "./campaign-tasks-landing-card.scss"


interface Props {
    className?: string
}

const CampaignTasksLandingCard = (props: Props) => {

    const checkBoxRefs = useRef<EmpCheckboxRef[]>([])
    const checkboxesWrapperRef = useRef<HTMLDivElement>(null)


    const inView = useInView(checkboxesWrapperRef, { amount: 1, once: true });


    useEffect(() => {
        if (!checkBoxRefs.current) return
        const currCheckboxRef = checkBoxRefs.current
        if (inView) {
            const BASE_DELAY_S = 300
            const STAGGER_DELAY_S = 300

            for (let i = 0; i < currCheckboxRef.length; i++) {
                setTimeout(() => {
                    currCheckboxRef[i].setChecked(true)
                }, BASE_DELAY_S + i * STAGGER_DELAY_S)
            }
        }
        else {
            for (let i = 0; i < currCheckboxRef.length; i++) {
                currCheckboxRef[i].setChecked(false)
            }
        }


    }, [inView])

    return (
        <div ref={checkboxesWrapperRef}>
            <div className='emrg-demo-cards task-main-card-wrapper'>
                <div className='card-header'>
                    <h3>Create Campaign Tasks</h3>
                    <p className='color-gray-300'>Specify your expectations and deliverables for the hired talents for your campaign</p>
                </div>
                <div className='v-stack card-content-wrapper'>
                    <div className="task-wrapper">
                        <div className="header-wrapper">
                            <span className="task-header">New Smart Desk</span>
                            <span className="additional-tasks-lbl">6 Tasks</span>
                        </div>
                        <div className="mt-8">
                            <EmpCheckbox ref={(el: EmpCheckboxRef) => checkBoxRefs.current[0] = el} className="mt-4" id="task-1" labelText="Product Post on Instagram" />
                            <EmpCheckbox ref={(el: EmpCheckboxRef) => checkBoxRefs.current[1] = el} className="mt-4" id="task-2" labelText="Create an Insta-story" />
                            <EmpCheckbox ref={(el: EmpCheckboxRef) => checkBoxRefs.current[2] = el} className="mt-4" id="task-3" labelText="Talk about it on stream" />
                            <span className="additional-tasks-lbl block mt-4 pl-6">+ 3 others</span>
                        </div>
                    </div>

                </div>
            </div>
        </div >
    )
}
export default CampaignTasksLandingCard
